<script setup lang="ts">

import { timezones } from '@shared/config'
import { TzSelect } from '@shared/ui/fields'

import { useTzDisplay } from '../composables/use-tz-display.hook'

defineOptions({
  name: 'TzDisplay',
})

const {
  refValue,
  setTimezone,
} = useTzDisplay()
</script>

<template>
  <TzSelect
    :key="refValue"
    :value="refValue"
    :timezones="timezones"
    @option:selected="setTimezone"
  />
</template>
